/** @jsxImportSource @emotion/react */
import { CircularProgress } from '@mui/material'
import { FC } from 'react'
import * as classes from './styles'

type Props = {
  className?: string
}

export const Loader: FC<Props> = (props) => (
  <div {...props} css={classes.progressWrapper}>
    <CircularProgress />
  </div>
)
